import { Form, Slider, Tooltip } from 'antd'
import Flex from 'components/Flex'
import InputNumber from 'components/Form/InputNumbers'
import React from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'

const StyledSlider = styled(Slider)`
  width: 95% !important;
  padding: 0px !important;
  height: 2px !important;
  margin: 10px 10px !important;
  margin-bottom: 30px !important;
  .ant-slider-handle {
    width: 20px;
    height: 20px;
    margin-top: -9px;
    background: ${COLORS.WHITE};
    border: 1px solid ${COLORS.GREY_T_95};
    box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  }
  .ant-slider-track {
    background-color: ${COLORS.PRIMARY} !important;
  }
  .ant-slider-rail,
  .ant-slider-track {
    height: 4px !important;
  }
  .ant-slider-dot {
    border: none !important;
  }
  .ant-slider-mark-text {
    transform: none !important ;
  }
`
const StyledStrong = styled.strong`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: ${COLORS.GREY_T_60};
`
const StyledFormItem = styled(Form.Item)`
  width: 100%;
  margin-bottom: ${props =>
    props?.marginBottom ? props?.marginBottom : '24px'} !important;
`
const RangeFlex = styled(Flex)`
  gap: 20px;
  margin-top: 20px;
`
const StyledInput = styled(InputNumber)`
  padding-top: 0px !important;
  .ant-input-number-handler-wrap {
    display: none;
  }
  background-color: ${props =>
    props?.borderColor ? props?.borderColor : 'transparent'} !important;
  border-radius: ${props =>
    props?.borderRadius ? props?.borderRadius : '8px'} !important;
  padding-top: ${props =>
    props?.paddingTop ? props?.paddingTop : '5px'} !important;
  width: ${props =>
    props?.inputWidth ? props?.inputWidth : '100%'} !important;
  top: ${props => (props?.top ? props?.top : '')} !important;
  color: ${props => (props?.color ? props?.color : 'black')} !important;
`

const RangeSliderInput = ({
  inputValue,
  setInputValue,
  defaultValue = 0,
  rules,
  min = 0,
  max = 100,
  step = 1,
  sliderrules,
  inputName,
  sliderName,
  onBlur,
  percentage = true,
  dependencies,
  hasFeedback,
  disabled = false,
  suffix,
  top,
  borderColor,
  inputWidth,
  color,
  inactiveErrorMessage,
  marginBottom,
  remainingValue = 0,
  errorMessage,
  setErrorMessages,
  id = '',
  index,
  isRanking = false,
  ...props
}) => {
  const marks = {
    [min]: {
      style: {
        marginTop: 'px',
      },
      label: <StyledStrong>{percentage ? `${min}%` : min}</StyledStrong>,
    },
    [max]: {
      style: {
        left: '90%',
        marginTop: '-6px',
      },
      label: <StyledStrong>{percentage ? `${max}%` : max}</StyledStrong>,
    },
  }

  const onChange = value => {
    setInputValue(value)
  }
  return (
    <Tooltip placement="topLeft" title={disabled ? inactiveErrorMessage : ''}>
      <div style={{ width: props.width ? props.width : '100%' }}>
        <RangeFlex centreVertically>
          <StyledFormItem
            name={sliderName}
            rules={sliderrules}
            initialValue={inputValue || 0}
            dependencies={dependencies}
            hasFeedback={hasFeedback}
            marginBottom={marginBottom}
          >
            <StyledSlider
              disabled={disabled}
              step={step}
              onChange={onChange}
              marks={marks}
              min={min}
              max={max}
              value={typeof inputValue === 'number' ? inputValue : 0}
              {...props}
            />
          </StyledFormItem>

          <div style={{ pointerEvents: isRanking ? 'none' : '' }}>
            <StyledInput
              width="20px"
              type="number"
              min={min}
              color={color}
              inputWidth={inputWidth}
              borderColor={borderColor}
              top={top}
              max={max}
              suffix={suffix}
              defaultValue={Number(inputValue) ? Number(inputValue) : 0}
              value={inputValue}
              onChange={onChange}
              onKeyDown={e =>
                ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()
              }
              name={inputName}
              onBlur={onBlur}
              disabled={disabled}
              {...props}
            />
          </div>
        </RangeFlex>
        <div style={{ color: 'red', marginLeft: '2%' }}>
          {id == index && errorMessage !== '' ? errorMessage : ''}
        </div>
      </div>
    </Tooltip>
  )
}

export default RangeSliderInput
